import { useLazyQuery } from '@apollo/client'
import { TEST_SESSION_MEMBER } from './operations'
import { TestSessionMember, TestSessionMemberVariables } from '../../types'

interface UseTestSessionMemberProps {
  onCompleted?: (data: TestSessionMember) => void
}

export const useTestSessionMember = ({ onCompleted }: UseTestSessionMemberProps) =>
  useLazyQuery<TestSessionMember, TestSessionMemberVariables>(TEST_SESSION_MEMBER, { onCompleted })
